import React from 'react'

const TripsPrivate = () => (
  <article>
    <h2>Private expeditions</h2>
    As well as working with travel companies, Sue can also arrange bespoke trips
    for small parties to destinations, and on dates, of their choosing. To start
    a discussion about the possibilities, please contact info@sueflood.com
  </article>
)

export default TripsPrivate
